import { render, staticRenderFns } from "./oncologyfield.vue?vue&type=template&id=710d7aca&scoped=true&"
import script from "./oncologyfield.vue?vue&type=script&lang=ts&"
export * from "./oncologyfield.vue?vue&type=script&lang=ts&"
import style1 from "./oncologyfield.vue?vue&type=style&index=1&id=710d7aca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710d7aca",
  null
  
)

export default component.exports